import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import isEmpty from "lodash/isEmpty";
import { Menu } from "../../types/Menu";
import { Nav } from "../../types/Nav";
import { NavItemLink } from "../NavItemLink";
import { Box } from "../Box";
import { NavDropDownItem } from "../NavDropDownItem";
import { Image } from "../Image";
import { Link } from "../Link";
import { Flex } from "../Flex";
import { getBorderColor, getOpacity } from "./_/selectedNavItem";

import Search from "../../assets/images/search.svg";
import smallArrowDown from "../../assets/images/vctr-small-down-arrow.svg";
import smallArrowUp from "../../assets/images/vctr-small-up-arrow.svg";

interface Props {
  currentPath: string;
}
const StyledFlex = styled(Flex)`
  @media (max-width: 992px) {
    display: none;
  }
`;
const StyledNavLink = styled(Box)`
  &:hover {
    background-color: rgb(0, 94, 235);
    opacity: 1;
  }
`;
export const NavBar: React.FC<Props & Menu & Nav> = ({ menu, nav }) => {
  const location = useLocation();
  const [hover, setHover] = useState(false);
  const handleHover = () => {
    if (hover) {
      setHover(false);
    } else {
      setHover(true);
    }
  };
  return (
    <StyledFlex data-testid="NavBar" px="15px" justifyContent="space-between">
      <Flex>
        {menu.map(item =>
          isEmpty(item.subMenu) ? (
            <StyledNavLink key={item.title} bg={getBorderColor(location.pathname, item)} opacity={getOpacity(location.pathname, item)}>
              <NavItemLink href={item.url}>{item.title}</NavItemLink>
            </StyledNavLink>
          ) : (
            <NavDropDownItem key={item.title} {...item}>
              <StyledNavLink bg={getBorderColor(location.pathname, item)} opacity={getOpacity(location.pathname, item)}>
                <NavItemLink href={item.url}>{item.title}</NavItemLink>
              </StyledNavLink>
            </NavDropDownItem>
          ),
        )}
      </Flex>
      <Flex>
        <NavDropDownItem onMouseEnter={handleHover} onMouseLeave={handleHover} {...nav}>
          <StyledNavLink bg={getBorderColor(location.pathname, nav)} opacity={getOpacity(location.pathname, nav)}>
            <NavItemLink href={nav.url}>
              <Box>
                {nav.title}
                {hover ? (
                  <Image src={smallArrowUp} alt="up-arrow" width="16px" mx="6px" />
                ) : (
                  <Image src={smallArrowDown} alt="down-arrow" width="16px" mx="6px" />
                )}
              </Box>
            </NavItemLink>
          </StyledNavLink>
        </NavDropDownItem>
        <Link href="https://www.vector.co.nz/special-pages/search">
          <Image data-testid="SearchLink" src={Search} alt="search-icon" px={1} mt="10px" />
        </Link>
      </Flex>
    </StyledFlex>
  );
};
